"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconClothes = function IconClothes(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M19.573 5.88 19.466 5H12.22a3.02 3.02 0 0 0-1.977.778L3.237 12.61l6.772 6.594L12 17.214V43h24V17.245l1.995 1.995 6.763-6.674-6.88-6.712A3 3 0 0 0 35.78 5h-7.245l-.107.88a4.46 4.46 0 0 1-8.854 0m10.67 1.119H34v34H14V7l3.756-.001.012.046a6.461 6.461 0 0 0 12.392.243zM35 13.416V7h.78l.13.008a1 1 0 0 1 .57.277l5.422 5.289-3.897 3.846zM13 7h-.76a1 1 0 0 0-.616.229l-.106.097-5.416 5.283 3.888 3.785L13 13.385zm10 13v-1h-7v1z",
    clipRule: "evenodd"
  })));
};

export { IconClothes, IconClothes as default };
